<template>
  <div>
    <form 
      v-if="validation.step === 1" 
      style="margin-top: 2.2rem;">
      <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 0.5rem">
        <label style="color: #000000; font-size: 18px;"><strong>Ingresa No. de Identificación</strong></label>
      </div>
      <input 
        placeholder="Escribe tu número de identificación"
        :class="['', {'facial_access__input_error': step1Validated && (!form.rut || form.rut === '')}]"
        v-model="form.rut">
      <label style="margin-bottom: 0.5rem;"><strong style="color: #000; font-size: 18px;">Toma foto selfie</strong></label>
      <div :class="['facial_access__upload_file', {'facial_access__border_error': step1Validated && !form.user_photo}]">
        <div v-if="!form.user_photo" @click="openFacialDetection()" >
          <selfie-icon color="#757575"></selfie-icon>
        <p style="font-size: 18px; text-align: center; margin-top: -40px;">Click Aquí <touch-icon color="#757575"></touch-icon></p>
        </div>
        <div 
          v-else 
          style="position: relative; display: flex; justify-content: center; align-items: center; height: 100%;">
          <img 
            style="max-width: 220px; max-height: 220px;" 
            :src="form.user_photo">
          <span 
            @click="removeFile('user_photo')" 
            style="position: absolute; top: 1rem; right: 0.5rem; width: 26px; height: 26px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background-color: white; cursor: pointer">
            <DeleteIcon :width="'25px'" :height="'25px'" :color="'#ffa1a1'" />
          </span>
        </div>
      </div>
    </form>
    <form 
      v-else-if="validation.step === 2" 
      style="margin-top: 2.2rem;">
      <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 0.5rem">
        <label><strong style="color: #000; font-size: 18px;">Forma de ingreso</strong></label>
      </div>
      <fieldset 
        style="margin-bottom: 2.2rem; border: unset" 
        class="facial_access__option_group">
        <span>
          <input 
            v-model="form.access" 
            value="pedestrian" 
            id="access_pedestrian" 
            style="box-shadow: none;" 
            type="radio">
          <label 
            for="access_pedestrian" 
            style="margin-left: 0.5rem; font-size: 17px;">Peatonal</label>
        </span>
        <span>
          <input 
            v-model="form.access" 
            value="vehicle" 
            id="access_vehicle" 
            style="box-shadow: none;" 
            type="radio">
          <label 
            for="access_vehicle" 
            style="margin-left: 0.5rem; font-size: 17px;">Vehicular</label>
        </span>
      </fieldset>
      <div 
        style="display: flex; flex-direction: column;" 
        v-if="form.access === 'vehicle'">
        <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 0.5rem">
          <label><strong style="color: #000; font-size: 18px;">Ingresa Placa de Vehículo</strong></label>
        </div>
        <input 
          :class="['', {'facial_access__input_error': step2Validated && (!form.plate_number || form.plate_number === '')}]"
          v-model="form.plate_number" 
          placeholder="Escribe el número de la placa">
        <label 
          style="margin: 2.2rem 0 0.5rem 0;"><strong style="color: #000; font-size: 18px;">Tomar foto del vehículo</strong></label>
        <div :class="['facial_access__upload_file', {'facial_access__border_error': step2Validated && !form.vehicle_photo_url}]">
          <div 
            v-if="!form.vehicle_photo_url" 
            @click="openCamera('vehicle')" 
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 1rem 0; height: 100%;">
            <vehicle-icon color="#757575"></vehicle-icon>
            <p style="font-size: 18px; text-align: center;">Click Aquí <touch-icon color="#757575"></touch-icon></p>
          </div>
          <div 
            v-else 
            style="position: relative; display: flex; justify-content: center; align-items: center; height: 100%;">
            <img 
              style="max-width: 220px; max-height: 220px;" 
              :src="form.vehicle_photo_url">
            <span 
              @click="removeFile('vehicle_photo_url')" 
              style="position: absolute; top: 1rem; right: 0.5rem; width: 26px; height: 26px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background-color: white; cursor: pointer">
              <DeleteIcon 
                :width="'25px'" 
                :height="'25px'" 
                :color="'#ffa1a1'" />
            </span>
          </div>
          <input 
            @change="uploadGuestImage($event, 'vehicle')" 
            style="display: none;" 
            id="upload_vehicle" 
            type="file">
        </div>
      </div>
    </form>
    <form 
      v-else-if="validation.step === 3" 
      style="margin-top: 2.2rem; height: 100%;">
      <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 0.5rem">
        <label><strong style="font-size: 18px;">¿Ingresa Insumos o Equipos?</strong></label>
      </div>
      <fieldset 
        style="margin-bottom: 2.2rem;" 
        class="facial_access__option_group">
        <span>
          <input 
            value="not" 
            id="supplies_not" 
            v-model="form.supplies" 
            style="box-shadow: none;" 
            type="radio">
          <label 
            for="supplies_not" 
            style="margin-left: 0.5rem; font-size: 17px;">No</label>
        </span>
        <span>
          <input 
            value="yes" 
            id="supplies_yes" 
            v-model="form.supplies" 
            style="box-shadow: none;" 
            type="radio">
          <label 
            for="supplies_yes" 
            style="margin-left: 0.5rem; font-size: 17px;">Si</label>
        </span>
      </fieldset>
      <div 
        style="display: flex; flex-direction: column; margin-bottom: 1rem" 
        v-if="form.supplies === 'yes'">
        <label style="margin: 0 0 0.5rem 0; font-size: 18px;"><strong>Tomar foto del Insumo o equipo</strong></label>
        <div :class="['facial_access__upload_file', {'facial_access__border_error': step3Validated && !form.equipment_photo_url}]">
          <div 
            v-if="!form.equipment_photo_url" 
            @click="openCamera('supply')" 
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 1rem 0; height: 100%;">
            <supply-icon color="#757575"></supply-icon>
            <p style="font-size: 18px; text-align: center;">Click Aquí <touch-icon color="#757575"></touch-icon></p>
          </div>
          <div 
            v-else 
            style="position: relative; display: flex; justify-content: center; align-items: center; height: 100%;">
            <img 
              style="max-width: 220px; max-height: 220px;" 
              :src="form.equipment_photo_url">
            <span 
              @click="removeFile('equipment_photo_url')" 
              style="position: absolute; top: 1rem; right: 0.5rem; width: 26px; height: 26px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background-color: white; cursor: pointer">
              <DeleteIcon 
                :width="'25px'" 
                :height="'25px'" 
                :color="'#ffa1a1'" />
            </span>
          </div>
          <input 
            @change="uploadGuestImage($event, 'supply')" 
            style="display: none;" 
            id="upload_supply" 
            type="file">
        </div>
      </div>

      <div :class="['facial_access__politics', {'not_content': form.supplies === 'not'}]">
        <a href="https://politicas.fusepong.com/#/" target="_blank">Leer políticas de tratamiento de datos</a>
        <p>Al oprimir el botón "Finalizar registro" nos estas indicando que ya has leído nuestras políticas de tratamiento de datos</p>
      </div>

    </form>


   <Transition name="fade">
  <CameraCapture
    v-if="showCamera"
    class="facial_access__take_photo"
    :facial="true"
    :current-facing-mode="'user'" 
    :logo="logo"
    @captured="uploadGuestImage($event, 'user')"
    @close="showCamera = false"
  />
</Transition>

<Transition name="fade">
  <CameraCapture
    v-if="vehicleCamera"
    class="facial_access__take_photo"
    :facial="false"
    :current-facing-mode="'environment'"
    @captured="uploadGuestImage($event, 'vehicle')"
    @close="vehicleCamera = false"
  />
</Transition>

<Transition name="fade">
  <CameraCapture
    v-if="supplyCamera"
    class="facial_access__take_photo"
    :facial="false"
    :current-facing-mode="'environment'"
    @captured="uploadGuestImage($event, 'supply')"
    @close="supplyCamera = false"
  />
</Transition>
    </div>
</template>

<script lang="js">
import SelfieIcon from '../icons/SelfieIcon.vue';
import TouchIcon from '../icons/TouchIcon.vue';
import CameraCapture from '../CameraCapture.vue';
import compressImage from '../../../utils/image-compresor';
import DeleteIcon from '../icons/DeleteIcon.vue';
import FacialAccessService from '../../../services/FacialAccessService';
import SupplyIcon from '../icons/SupplyIcon.vue';
import VehicleIcon from '../icons/VehicleIcon.vue';

export default {
    name: 'EmpresarialView',
    components: {
        SelfieIcon,
        TouchIcon,
        CameraCapture,
        DeleteIcon,
        SupplyIcon,
        VehicleIcon,
    },
    data() {
        return {
            form: {
                rut: '',
                plate_number: '',
                access: 'pedestrian',
                supplies: 'not',
                equipment_photo_url: null,
                vehicle_photo_url: null,
                user_photo: null,
            },
            step1Validated: false,
            step2Validated: false,
            step3Validated: false,
            showCamera: false,
            vehicleCamera: false,
            supplyCamera: false,
        }
    },
    props: {
      validation: Object,
      basicData: Object,
      logo: String
    },
    methods: {
      async nextStep() {
        switch (this.validation.step) {
          case 1:
            this.step1Validated = true;
            if (this.validateStep1()) {
              this.validation.step = 2;
            }
            break;
          case 2:
            this.step2Validated = true;
            if (this.validateStep2()) {
              this.validation.step = 3;
            }
            break;
          case 3:
            this.step3Validated = true;
            if (this.validateStep3()) {
              await this.sendForm();
            }
        }
      },
      closed(event, target) {
        this.$emit('camera', false)
        if (event === 'not_allowed') {
          console.log(event, target);
          target === 'upload_vehicle' ? this.vehicleCamera = false : this.supplyCamera = false;
          this.uploadFile(target);
        }
      },
      validateStep1() {
        return !!this.form.user_photo && this.form.rut && this.form.rut !== '';
      },
      validateStep2() {
        if (this.form.access === 'vehicle') {
          // if (!this.form.plate_number || this.form.plate_number.length !== 6) {
          //   alert('La placa debe tener exactamente 6 caracteres.');
          //   return false;
          // }
          if (!this.form.plate_number) {
            alert('No ha colocado el numero de placa');
            return false;
          }
          if (!this.form.vehicle_photo_url) {
            return false;
          }
        }
        return true;
      },
      validateStep3() {
        if (this.form.supplies === 'yes') {
          return this.form.equipment_photo_url;
        }
        this.sendForm();
        return true;
      },
      async uploadGuestImage(event, destiny = 'user') {
        this.vehicleCamera = this.supplyCamera = this.showCamera = false;
        this.$emit('camera', false);
        
        let vm = this;

        const guest_img = event.target.files[0];
        const extension = event.target.files[0].type.split('/')[1];

        if (extension !== 'jpg' && extension !== 'jpeg') {
          alert('Solo se admite formato jpg o jpeg');
          return;
        }

        const blob = await compressImage(guest_img);

        const reader = new FileReader();

        reader.readAsDataURL(blob);
        reader.onload = () => {
          switch(destiny) {
          case 'user':
            vm.form.user_photo = reader.result;
            
            vm.validation.firstStepValid = true;
            break;
          case 'vehicle':
            vm.form.vehicle_photo_url = reader.result;
            break;
          case 'supply':
            vm.form.equipment_photo_url = reader.result;
            break;
          }
        }
      },
      removeFile(formName) {
        this.form[formName] = null;
        if (this.validation.step === 1) {
          this.validation.firstStepValid = false;
        }
      },
      uploadFile(selector) {
        document.getElementById(selector).click();
      },
      async sendForm() {
        this.$emit('loading', {value: 8, init: true, finish: false});
        this.basicData.rut = this.form.rut
        try {
          console.log('inicializar codifgo')
          console.log({...this.form, ...this.basicData })
          const response = await FacialAccessService.validateAccess(this.encrypt({ attributes: {...this.form, ...this.basicData }}).toString(), this.$http);
          console.log(response)
          if (response.status === 204 || response.status === 200) {
            this.$emit('finish', true);
            this.$emit('loading', {value: 2, init: false, finish: false});
          }

        
        } catch (e) {
          console.error(e);
          alert('Ha ocurrido un error al guardar la información')
        }
        this.$emit('loading', {value: 1, init: false, finish: true});
      },
      openFacialDetection() {
        this.showCamera = true;
        this.$emit('camera', true)
      },
      openCamera(camera) {
  // Cerramos cualquier rastro de la cámara selfie primero
  this.showCamera = false;
  this.$emit('camera', true);
  
  // Esperamos un "tick" de Vue para asegurar que el componente anterior se destruyó
  this.$nextTick(() => {
    if (camera === 'vehicle') {
      this.vehicleCamera = true;
      this.supplyCamera = false;
    } else {
      this.supplyCamera = true;
      this.vehicleCamera = false;
    }
  });
}
    },
    mounted() {
      this.validation.maxSteeps = 3;
    },
    watch: {
      'form.plate_number'(newValue) {
        this.form.plate_number = this.form.plate_number.toUpperCase();
      }
    }
}
</script>
<style>
</style>